import { z } from 'zod'
import { monosanFetch } from '@/shared/api/monosanFetch'
import { ApiError } from '@/shared/api/errors'

export const checkIbanReachability = async (iban: string): Promise<boolean> => {
  try {
    await monosanFetch(`/api/iban-validation?iban=${encodeURIComponent(iban)}`, {
      schema: z.unknown(),
    })
    return true
  } catch (err) {
    if (err instanceof ApiError && err.status === 422) return false
    throw err
  }
}
